var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandidateVideoAnswers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_717_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.87328 0C5.12553 0 5.32989 0.204367 5.32989 0.456615C5.32989 0.708862 5.12553 0.913229 4.87328 0.913229H0.913229V4.80321C0.913229 5.05546 0.708862 5.25983 0.456614 5.25983C0.204367 5.25983 0 5.05546 0 4.80321V0.456615C0 0.204367 0.204367 0 0.456614 0H4.87328ZM3.90516 8.3557C4.17142 7.97382 4.53578 7.70873 5.0683 7.64683H9.03069C9.64612 7.75894 10.0794 8.09878 10.376 8.61028V10.9938H3.90516V8.3557ZM7.08511 3.35746C8.12914 3.35746 8.9758 4.20412 8.9758 5.24815C8.9758 6.29217 8.12914 7.13884 7.08511 7.13884C6.04109 7.13884 5.19443 6.29217 5.19443 5.24815C5.19559 4.20296 6.04109 3.35746 7.08511 3.35746ZM9.40672 0.913229C9.15448 0.913229 8.95011 0.708862 8.95011 0.456615C8.95011 0.204367 9.15448 0 9.40672 0H13.8234C14.0756 0 14.28 0.204367 14.28 0.456615V4.80321C14.28 5.05546 14.0756 5.25983 13.8234 5.25983C13.5711 5.25983 13.3668 5.05546 13.3668 4.80321V0.913229H9.40672ZM9.40672 14.3501C9.15448 14.3501 8.95011 14.1457 8.95011 13.8935C8.95011 13.6412 9.15448 13.4368 9.40672 13.4368H13.3668V9.54686C13.3668 9.29462 13.5711 9.09025 13.8234 9.09025C14.0756 9.09025 14.28 9.29462 14.28 9.54686V13.8935C14.28 14.1457 14.0756 14.3501 13.8234 14.3501H9.40672ZM4.87328 13.4368C5.12553 13.4368 5.32989 13.6412 5.32989 13.8935C5.32989 14.1457 5.12553 14.3501 4.87328 14.3501H0.456614C0.204367 14.3501 0 14.1457 0 13.8935V9.54686C0 9.29462 0.204367 9.09025 0.456614 9.09025C0.708862 9.09025 0.913229 9.29462 0.913229 9.54686V13.4368H4.87328Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_717_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.28,
    height: 14.3501,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateVideoAnswers);
export default __webpack_public_path__ + "static/media/Candidate-Video-Answers.be19b64b4734d4fd30dfe725cd123b11.svg";
export { ForwardRef as ReactComponent };